<div class="filter-wrapper w100" style="margin-bottom: 8px">
  <div class="search-filter-wrapper">
    <mat-form-field appearance="outline" class="search-input-field dense-2" subscriptSizing="dynamic">
      <input [formControl]="searchControl" matInput placeholder="Suche...">
    </mat-form-field>
    @if (showDetailedSearch !== false) {
      <mat-form-field appearance="outline" class="search-select-field dense-2" subscriptSizing="dynamic">
        <mat-select [formControl]="searchOptionsControl">
          @for (option of searchOptionsList; track option) {
            <mat-option (click)="search.emit(getParams())"
              [value]="option">{{ option }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
  <div class="level-filter-mode-wrapper">
    <mat-button-toggle-group [formControl]="levelControl" aria-label="level" class="mat-button-toggle-group"
      multiple=true name="level" [hideSingleSelectionIndicator]=true [hideMultipleSelectionIndicator]=true>
      <mat-button-toggle (change)="onLevelToggle('A0')" value="A0" class="btn-toggle">
        @if (contains(levelControl.value,'A0')) {
          <span class="lang-level-search a0-checked">A0</span>
        }
        @if (!contains(levelControl.value,'A0')) {
          <span class="lang-level-search a0">A0</span>
        }
      </mat-button-toggle>
      <mat-button-toggle (change)="onLevelToggle('A1')" value="A1" class="btn-toggle">
        @if (contains(levelControl.value,'A1')) {
          <span class="lang-level-search a1-checked">A1</span>
        }
        @if (!contains(levelControl.value,'A1')) {
          <span class="lang-level-search a1">A1</span>
        }
      </mat-button-toggle>
      <mat-button-toggle (change)="onLevelToggle('A2')" value="A2" class="btn-toggle">
        @if (contains(levelControl.value,'A2')) {
          <span class="lang-level-search a2-checked">A2</span>
        }
        @if (!contains(levelControl.value,'A2')) {
          <span class="lang-level-search a2">A2</span>
        }
      </mat-button-toggle>
      <mat-button-toggle (change)="onLevelToggle('B1')" value="B1" class="btn-toggle">
        @if (contains(levelControl.value,'B1')) {
          <span class="lang-level-search b1-checked">B1</span>
        }
        @if (!contains(levelControl.value,'B1')) {
          <span class="lang-level-search b1">B1</span>
        }
      </mat-button-toggle>
      <mat-button-toggle (change)="onLevelToggle('B2')" value="B2" class="btn-toggle">
        @if (contains(levelControl.value,'B2')) {
          <span class="lang-level-search b2-checked">B2</span>
        }
        @if (!contains(levelControl.value,'B2')) {
          <span class="lang-level-search b2">B2</span>
        }
      </mat-button-toggle>
      <mat-button-toggle (change)="onLevelToggle('C1')" value="C1" class="btn-toggle">
        @if (contains(levelControl.value,'C1')) {
          <span class="lang-level-search c1-checked">C1</span>
        }
        @if (!contains(levelControl.value,'C1')) {
          <span class="lang-level-search c1">C1</span>
        }
      </mat-button-toggle>
      <mat-button-toggle (change)="onLevelToggle('C2')" value="C2" class="btn-toggle">
        @if (contains(levelControl.value,'C2')) {
          <span class="lang-level-search c2-checked">C2</span>
        }
        @if (!contains(levelControl.value,'C2')) {
          <span class="lang-level-search c2">C2</span>
        }
      </mat-button-toggle>
      <mat-button-toggle (change)="onLevelToggle('NONE')" value="NONE" class="btn-toggle">
        @if (contains(levelControl.value,'NONE')) {
          <span class="lang-level-search all-checked">Offen</span>
        }
        @if (!contains(levelControl.value,'NONE')) {
          <span class="lang-level-search all">Offen</span>
        }
      </mat-button-toggle>
    </mat-button-toggle-group>
    <mat-form-field class="dense-2 lang-level-select" subscriptSizing="dynamic" appearance="outline">
      <mat-select [formControl]="levelFilterModeControl">
        @for (option of levelFilterModeList; track option) {
          <mat-option (click)="search.emit(getParams())"
            [value]="option">{{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
    @if (showDetailedSearch !== false) {
      <button
        (click)="panel1.toggle(); changeViewSize()"
        aria-label="Button for advanced searching inputs"
        class="filter-button"
        color="primary"
        matTooltip="Erweiterte Suche einblenden"
        matTooltipShowDelay="1000"
        matTooltipPosition="above"
        matTooltipHideDelay="200"
        mat-flat-button>
        <mat-icon>settings</mat-icon>
        <span class="button-text">Erweiterte Suche</span>
      </button>
    }
  <button
    (click)="deleteFilter()"
    class="filter-button"
    matTooltip="Filter zurücksetzen"
    matTooltipShowDelay="1000"
    matTooltipPosition="above"
    matTooltipHideDelay="200"
    color="warn"
    mat-flat-button>
    <mat-icon aria-label="Button to delete search inputs">delete</mat-icon>
    <span class="button-text">Filter löschen</span>
  </button>
</div>
<mat-accordion class="prevent-click">
  <mat-expansion-panel #panel1 [hideToggle]="true" class="dense-1" id="panel" style="box-shadow: none !important;"
                       [disabled]="showDetailedSearch === false">
    <div class="form-group">
      <div class="sub-form-group">
        <mat-form-field appearance="outline" class="advanced-form-field" subscriptSizing="dynamic">
          <mat-label>Wortart</mat-label>
          <mat-select [formControl]="typeControl" multiple>
            @for (type of typeList; track type) {
              <mat-option (click)="search.emit(getParams())"
                [value]="type">{{ type }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="advanced-form-field" subscriptSizing="dynamic">
          <mat-label>Variante</mat-label>
          <mat-select [formControl]="countryControl" multiple>
            <mat-select-trigger>
              {{ countryControl.value ? countryControl.value[0] : '' }}
              @if (countryControl.value?.length > 1) {
                <span
                  class="additional-selection">(+{{ countryControl.value.length - 1 }} {{
                  countryControl.value?.length === 2 ?
                  'anderes' : 'andere'
                  }})
                </span>
              }
            </mat-select-trigger>
            @for (country of countryList; track country) {
              <mat-option (click)="search.emit(getParams())"
                [value]="country">{{ country }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="sub-form-group">
        <mat-form-field appearance="outline" class="advanced-form-field" subscriptSizing="dynamic">
          <mat-label>Eintrag</mat-label>
          <mat-select [formControl]="wordFieldControl">
            @for (option of wordFieldList; track option) {
              <mat-option (click)="search.emit(getParams())"
                [value]="option">{{ option }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="advanced-form-field" subscriptSizing="dynamic">
          <mat-label>Tests</mat-label>
          <input (keyup)="search.emit(getParams())" [formControl]="testsControl" [matAutocomplete]="auto" aria-label="Number" matInput
            placeholder="SD1" type="text">
            <mat-autocomplete #auto="matAutocomplete">
              @for (filteredTest of filteredTests | async; track filteredTest) {
                <mat-option (click)="search.emit(getParams())"
                  [value]="filteredTest">
                  {{ filteredTest }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
